// extracted by mini-css-extract-plugin
export default {"updateAvailableTag":"CriteriaViewUpdateComponent_updateAvailableTag_ngQ5L","spinAround":"CriteriaViewUpdateComponent_spinAround_H546R"};